import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Card, Badge } from "../../components/ui/Card";
import { formatPrice } from "../../lib/utils";

const STATUS_VARIANT = { active: "accent", depleted: "default", expired: "default" };

export default function Packages() {
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/my-packages")
      .then(({ data }) => setPackages(data))
      .catch(() => setPackages([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <p className="text-muted-foreground">Loading…</p>;

  return (
    <div>
      <h1 className="mb-4 font-montserrat text-2xl font-bold text-slate-900">Packages</h1>
      {packages.length === 0 ? (
        <p className="text-muted-foreground">You don't have any packages yet — look for them on a business profile.</p>
      ) : (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
          {packages.map((p) => (
            <Card key={p.id} className="p-4">
              <div className="flex items-center justify-between">
                <p className="font-semibold text-slate-900">{p.service_package?.name}</p>
                <Badge variant={STATUS_VARIANT[p.status] || "default"}>{p.status === "pending" ? "Awaiting payment" : p.status}</Badge>
              </div>
              <p className="text-sm text-muted-foreground">{p.business?.name}</p>
              {p.status === "pending" && (
                <p className="mt-1 text-xs text-amber-700">Pay at the store — it activates once they confirm your payment.</p>
              )}
              <p className="mt-2 text-2xl font-bold text-slate-900">
                {p.sessions_remaining} <span className="text-sm font-normal text-muted-foreground">of {p.sessions_total} sessions left</span>
              </p>
              <p className="text-xs text-muted-foreground">
                {p.service_package?.service?.name} · paid {formatPrice(p.purchased_price)}
                {p.expires_at && ` · expires ${new Date(p.expires_at).toLocaleDateString()}`}
              </p>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
